var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7.99976,
    r: 8,
    fill: "#F38A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42064 11.7498C7.10258 12.0831 6.57184 12.0831 6.25378 11.7498L3.23779 8.58939C2.92074 8.25715 2.92074 7.70429 3.23779 7.37205L3.89186 6.68666C4.20973 6.35358 4.72185 6.35337 5.03995 6.68603L6.8452 8.56098L10.9595 4.24972C11.2775 3.91643 11.7901 3.91643 12.1081 4.24972L12.7622 4.93511C13.0793 5.26735 13.0793 5.82021 12.7622 6.15245L7.42064 11.7498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIconOrange);
export default __webpack_public_path__ + "static/media/checked-icon-orange.6f308fe02a86b387c1ac97d9c0883343.svg";
export { ForwardRef as ReactComponent };